// extracted by mini-css-extract-plugin
module.exports = {"root":"autoload-subscribed_root__G5f6W","arrow":"autoload-subscribed_arrow__2ktbb"};